import { BodyText, Header2 } from 'components/UI/Brand/text';
import Icon from 'components/UI/Icons/Icon';
import translate from 'translate';
import { colors } from 'style/colors';
import styles from './styles.module.scss';

const NotFound = () => (
  <div className={styles.container}>
    <Header2 className={styles.title}>
      {translate('PageNotFound_Title')}
    </Header2>
    <Icon
      iconType="searchAlert"
      width={80}
      height={80}
      color={colors.shared.warmGray3}
    />
    <BodyText className={styles.description}>
      {translate(
        'PageNotFound_Description',
        <a href="/" className={styles.link}>
          {translate('PageNotFound_DescriptionLink')}
        </a>
      )}
    </BodyText>
  </div>
);

export default NotFound;
